import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../mock";

const FAQ = () => {
  return (
    <section id="faq" className="py-24 md:py-32 bg-[#efe7d6]">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16 reveal">
          <p className="kicker mb-5">Frequently Asked Questions</p>
          <h2 className="font-display display-tight text-5xl md:text-6xl text-[#1f1d1a]">
            Got a question?<br/>
            <span className="italic font-light">We may have answered it.</span>
          </h2>
          <div className="section-rule mx-auto mt-8" />
        </div>

        <Accordion type="single" collapsible className="reveal">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="faq-item border-x-0">
              <AccordionTrigger className="text-left py-6 hover:no-underline group">
                <div className="flex items-start gap-5 pr-4">
                  <span className="text-[0.7rem] tracking-[0.25em] text-[#8b6f47] mt-2 font-medium">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-display text-xl md:text-2xl text-[#1f1d1a] display-tight group-hover:text-[#8b6f47] transition-colors">
                    {f.q}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pl-12 pr-4 pb-6">
                <p className="text-[#3a342c] font-light leading-relaxed text-[0.95rem]">{f.a}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
